import React from "react";
import { Card, Dropdown, Badge } from "react-bootstrap";
import ReactApexChart from "react-apexcharts";

const CompaniesChart = () => {
  const options = {
    chart: { type: "bar", toolbar: { show: false } },
    colors: ["#1E252B"],
    grid: { borderColor: "#e9ecef", strokeDashArray: 5 },
    plotOptions: {
      bar: {
     //    columnWidth: "50%",
        borderRadius: 16,
        borderRadiusApplication: "end",
      },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: ["M", "T", "W", "T", "F", "S", "S"],
      labels: { style: { colors: "#6c757d", fontSize: "13px" } },
    },
    yaxis: { show: false },
  };

  const series = [{ name: "Company", data: [35, 60, 25, 80, 60, 60, 60] }];

  return (
    <Card
      className="shadow-sm border-0 d-flex flex-column h-100  m-0"
      style={{ borderRadius: "14px" }}
    >
      <Card.Header className="bg-white border-0 d-flex justify-content-between align-items-center">
        <h5 className="fw-semibold">Companies</h5>
        <Dropdown>
          <Dropdown.Toggle size="sm" variant="light" className="border">
            This Week
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item>This Month</Dropdown.Item>
            <Dropdown.Item>This Week</Dropdown.Item>
            <Dropdown.Item>Today</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      <Card.Body className="flex-grow-1">
        <ReactApexChart
          options={options}
          series={series}
          type="bar"
          height={290}
        />
        <div className="mt-3">
          <Badge bg="success" className="me-2">
            +6%
          </Badge>
          <span style={{ fontSize: "13px", color: "#6c757d" }}>
            5 Companies from last month
          </span>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CompaniesChart;
